var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVehiculos = function SvgVehiculos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "vehiculos_svg__Capa_2",
    viewBox: "0 0 66.04 58.37"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vehiculos_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.19,
    height: 17.79,
    y: 40.58,
    rx: 3.53,
    ry: 3.53,
    fill: "#500d76"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.19,
    height: 17.79,
    x: 52.84,
    y: 40.58,
    rx: 3.53,
    ry: 3.53,
    fill: "#500d76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.13 21.77-2-.86a3.12 3.12 0 0 1-1.81-2.14L56.34 2.41C56 1 54.74.01 53.29.01H12.76c-1.45 0-2.71.99-3.05 2.4L5.73 18.77c-.23.96-.91 1.75-1.81 2.14l-2 .86a3.14 3.14 0 0 0-1.9 2.89V46.4c0 1.73 1.41 3.14 3.14 3.14h59.76c1.73 0 3.14-1.41 3.14-3.14V24.66c0-1.26-.75-2.39-1.9-2.89Z",
    fill: "#2ad2c5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.2,
    cy: 32.46,
    r: 4.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.84,
    cy: 32.46,
    r: 4.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3 21.52H7.96l4.52-16.03c.37-1.3 1.55-2.2 2.91-2.2h35.28c1.4 0 2.62.97 2.94 2.34z",
    fill: "#500d76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4 43.56c.22.49.61.77 1.03.77H43.9c.41 0 .79-.29 1.03-.77l1.57-3.34c.55-1.17-.03-2.73-1.03-2.73H18.84c-.99 0-1.57 1.56-1.03 2.73z",
    fill: "#22aa9f"
  }))));
};
export default SvgVehiculos;